import { handleActions } from "redux-actions";
import { INTEGRATIONS } from "constants/action-types";

interface IState {
    error?: boolean;
    errorMessage?: any;
    fetching?: boolean;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    errorMessage: undefined,
    fetching: false,
    results: [],
};

export const schemaMap = handleActions<IState, any>(
    {
        [INTEGRATIONS.BRAND_SCHEMA_MAP.FETCH.START]: (state: IState): IState => {
            return { ...state, fetching: true };
        },
        [INTEGRATIONS.BRAND_SCHEMA_MAP.FETCH.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorMessage: payload,
                    fetching: false,
                    results: state.results,
                };
            }
            return {
                ...state,
                error: false,
                errorMessage: undefined,
                fetching: false,
                results: payload,
            };
        },
        [INTEGRATIONS.BRAND_SCHEMA_MAP.CREATE.START]: (state: IState): IState => {
            return { ...state, fetching: true };
        },
        [INTEGRATIONS.BRAND_SCHEMA_MAP.CREATE.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorMessage: payload,
                    fetching: false,
                    results: state.results,
                };
            }
            return {
                ...state,
                error: false,
                errorMessage: undefined,
                fetching: false,
                results: payload,
            };
        },
        [INTEGRATIONS.BRAND_SCHEMA_MAP.UPDATE.START]: (state: IState): IState => {
            return { ...state, fetching: true };
        },
        [INTEGRATIONS.BRAND_SCHEMA_MAP.UPDATE.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorMessage: payload,
                    fetching: false,
                    results: payload.status === 404 ? [] : state.results,
                };
            }
            return {
                ...state,
                error: false,
                errorMessage: undefined,
                fetching: false,
                results: payload,
            };
        },
        [INTEGRATIONS.BRAND_SCHEMA_MAP.RESET]: (): IState => {
            return {
                ...initialState,
            };
        },
    } as any,
    initialState
);
